"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const react_1 = __importStar(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const text_area_styles_1 = require("./text-area-styles");
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
exports.TextArea = react_1.forwardRef(function TextArea({ form, onChange, disabled, value, onBlur, onFocus, startAdornment, endAdornment, onChangeEvent, error = false, minRows = 3, maxRows = 12, }, ref) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : '';
    const handleChange = event_callback_hook_1.useEventCallback((e) => {
        if (onChangeEvent !== undefined) {
            onChangeEvent(e);
        }
        if (onChange !== undefined) {
            const value = e.target.value;
            onChange(value !== '' ? value : null);
        }
    });
    const classes = text_area_styles_1.useStyles();
    startAdornment = startAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, startAdornment));
    endAdornment = endAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, endAdornment));
    return (react_1.default.createElement(TextField_1.default, { InputProps: {
            classes,
            startAdornment,
            endAdornment,
        }, inputProps: {
            form,
            spellCheck: 'true',
        }, ref: ref, disabled: disabled, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, error: error, fullWidth: true, lang: "cs", multiline: true, rows: minRows, rowsMax: maxRows }));
});
//# sourceMappingURL=text-area.js.map